import { GET_CONFIGURATION } from "../actions/types";

export default function(state = null, action: any) {
  switch (action.type) {
    case GET_CONFIGURATION:
      return action.payload;
    default:
      return state;
  }
}
